import queryString from 'query-string';
import request from '@meitu/saas-editor-ui/es/request';
import { toSnakeDict } from '@meitu/util';
import { isInternalDesignerMode } from '@/utils/auth';
import {
    ArtTextMaterialRaw,
    FetchArtTextMaterialResponse,
    FetchDefaultFontParams,
    FetchDefaultFontResponseOfDesign,
    FetchDefaultFontResponseOfUser,
    FetchFontCategoryListParams,
    FetchFontCategoryListResponseOfDesigner,
    FetchFontCategoryListResponseOfInternalDesigner,
    FetchFontListParams,
    FetchInternalDesignerRespone,
    FetchListStyleMaterialsResponse,
    ListStyleMaterialRaw,
} from './index.d';

export { toEditorFormat, toWidgetFormat } from './transform';

/**
 * 获取列表字体
 * @param params
 * @returns
 */
export const fetchFontList = async function (params: FetchFontListParams) {
    if (isInternalDesignerMode()) {
        return await fetchInternalDesignerFontList({
            ...params,
            limit: 1000,
        });
    }
    return await fetchDesignerFontList({ ...params, limit: 1000 });
};

/**
 * 获取字体列表 设计师  https://api-mock.meitu-int.com/project/1289/interface/api/67890
 * @param params
 * @returns
 */

export const fetchDesignerFontList = async function name(params: FetchFontListParams) {
    const res = await request<FetchInternalDesignerRespone>('/seal_pie/font_list.json', {
        method: 'GET',
        params,
    });
    return res.data.response?.materials || [];
};

export const fetchFontCategoryList = async function (params: FetchFontCategoryListParams) {
    if (isInternalDesignerMode()) {
        return await fetchFontCategoryListOfInternalDesigner(params);
    }
    return await fetchFontCategoryListOfDesigner(params);
};
/**
 * 获取字体列表 内部设计师https://api-mock.meitu-int.com/project/1289/interface/api/82357
 * @param params
 * @returns
 */
export const fetchInternalDesignerFontList = async function (params: FetchFontListParams) {
    const res = await request<FetchInternalDesignerRespone>('/seal_pie_internal/font_list.json', {
        method: 'GET',
        params,
    });
    return res.data.response?.materials || [];
};

/**
 * 内部设计师字体分类 https://api-mock.meitu-int.com/project/1289/interface/api/82364
 * @param params
 * @returns
 */
export const fetchFontCategoryListOfInternalDesigner = async function (params: FetchFontCategoryListParams) {
    const { client_id: clientId, language, preview_mode: previewMode, oam, app_src } = params;
    return await request<FetchFontCategoryListResponseOfInternalDesigner>(
        '/v2/seal_pie_internal/font_category_list.json',
        {
            method: 'GET',
            params: {
                app_src,
                ...toSnakeDict({ clientId, language, previewMode, oam }),
                oam: (queryString.parse(window.location.search).oam as string) || undefined,
            },
        },
    ).then((axiosResponse) => axiosResponse.data.response);
};

/**
 * 设计师体字体分类 https://api-mock.meitu-int.com/project/1289/interface/api/75051
 * @param params
 * @returns
 */
export const fetchFontCategoryListOfDesigner = async function (params: FetchFontCategoryListParams) {
    return await request<FetchFontCategoryListResponseOfDesigner>('/v2/seal_pie/font_category_list.json', {
        method: 'GET',
        params,
    }).then((axiosResponse) => {
        return axiosResponse.data.response;
    });
};

export const fetchDefaultFontByUser = async function (params: FetchDefaultFontParams) {
    return await request<FetchDefaultFontResponseOfUser>('/common/web_init.json', {
        method: 'GET',
        params,
    }).then((axiosResponse) => {
        return {
            default_font: axiosResponse.data.data.default_font,
            fontUrl: axiosResponse.data.data.default_font_material.meta.font_file.url,
        };
    });
};

export const fetchDefaultFontByDesign = async function (params: FetchDefaultFontParams) {
    return await request<FetchDefaultFontResponseOfDesign>(
        !isInternalDesignerMode() ? 'seal_pie/web_init.json' : 'seal_pie_internal/web_init.json',
        {
            method: 'GET',
            params,
        },
    ).then((axiosResponse) => {
        return {
            default_font: axiosResponse.data.response.default_font,
            fontUrl: axiosResponse.data.response.default_font_material.material.meta.font_file.url,
        };
    });
};

export const fetchDefaultFont = async function (params: FetchDefaultFontParams) {
    return await fetchDefaultFontByDesign({
        ...params,
    });
};

/**
 * 接口 [获取列表样式素材]
 *
 */
export const fetchListStyleMaterials = async () => {
    const result = await request<FetchListStyleMaterialsResponse>('/seal_pie_internal/material_list.json', {
        method: 'GET',
        params: {
            type: 'text_list_style',
            limit: 100, // 列表素材不走分页交互，count 传递稍大一点的值
        },
    });

    if (!result.data.response) return [] as ListStyleMaterialRaw[];

    const list = result.data.response.materials || [];
    return list;
};

/**
 * 接口 [获取文字特效素材] https://api-mock.meitu-int.com/project/1289/interface/api/105537
 *
 */
export const fetchArtTextMaterials = async () => {
    const result = await request<FetchArtTextMaterialResponse>(`/seal_pie_internal/material_list.json`, {
        method: 'GET',
        params: {
            type: 'text_effect',
            count: 100, // 文字特效素材不走分页交互，count 传递稍大一点的值
        },
        hideErrorToast: true,
    });

    if (!result.data.response) return [] as ArtTextMaterialRaw[];

    const list = result.data.response.materials || [];
    return list;
};
